<template>
  <b-card title="3rd Party Credit">
    <div class="d-flex align-items-center">
      <b>2Captcha</b>
      <span class="ml-auto">$ 980</span>
    </div>
  </b-card>
</template>

<script>
import api from "@api";

export default {
  name: `3rdPartyCredit`,
  data() {
    return {
      creditList: [],
    };
  },
  computed: {
    sortedCreditList() {
      return this.creditList.sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  async mounted() {
    this.loadCredit();
  },
  methods: {
    loadCredit() {
      this.load2Captcha();
    },
    load2Captcha() {
      var payload = { clientKey: "38b6f9af48fa30f8f439b2f14feb0da5" };
      var result = this.$http.post("https://api.2captcha.com/getBalance", payload);
      console.log(result);
    },
  },
};
</script>
